import React from 'react';
import PropTypes from 'prop-types';
import { injectPageTitle, pageTitleShape } from '../../providers/PageTitleProvider';

class PageTitle extends React.PureComponent {
  static defaultPropTypes = {
    title: '',
    category: '',
    shortTitle: '',
  };

  static propTypes = {
    pageTitle: pageTitleShape,
    title: PropTypes.string,
    shortTitle: PropTypes.string,
    category: PropTypes.string,
    subTitle: PropTypes.string,
  };

  componentDidMount() {
    const { title, category, shortTitle, pageTitle, subTitle } = this.props;
    pageTitle.set(title, category, shortTitle, subTitle);
  }

  componentWillUnmount() {
    this.props.pageTitle.set();
  }

  /* eslint-disable class-methods-use-this */
  render() {
    return null;
  }
}

export default injectPageTitle(PageTitle);
